module.exports = __webpack_public_path__ + "img/cn3.fb64944.png";